import React, { Component } from 'react'

/* Styles */
import './SwitchingContainer.css'

/* Components */
import SwitchingContainerView from './SwitchingContainerView';

// Modules
import { getChamp } from '../../utils/champsFunctions';
import { getRotationsFromChamp, getSwitchingsFromChamp } from '../../utils/confrontationsFunctions';
import { getCompetitorsFromChamp, getTeams } from '../../utils/competitorsFunctions';

class SwitchingContainer extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,

            loadingSwitchingList: true,
            switchingList: [],

            switchingId: null,
        }
    }

    componentWillMount = async () => {
        // Get the champ info
        let arrayOfRoute = this.props.location.pathname.split('/')

        /* Get specific champ object */
        const champId = arrayOfRoute[3];
        const champ = await getChamp(champId);
        this.setState({
            champObject: champ,
            champId: champId,
        });

        // Get list of switchings
        let localArrayOfswitching = []
        for (let i = 0; i < 313; i++) {
            localArrayOfswitching.push({ 'n': i, 'color': '' })
        }
        // Get color of switchings
        const switchings = await getSwitchingsFromChamp(champId);
        switchings.forEach(childSnap => {
            if (localArrayOfswitching[childSnap.__key])
                localArrayOfswitching[childSnap.__key - 1]['color'] = childSnap.faixa;
        });
        this.setState({
            switchingList: localArrayOfswitching,
            loadingSwitchingList: false,
        });

        /* Get all competitors */
        let localArrayOfCompetitors = await getCompetitorsFromChamp(champId);

        sessionStorage.setItem('switchingArrayOfCompetitors', JSON.stringify(localArrayOfCompetitors));

        /* Get all champios */
        /* Get champions of every switching */
        let championsArray = [];
        switchings.forEach(switching => {
            /* Don't get champion of absolut */
            if (switching.__key < 100) {
                let count = 0, countChamp = 0
                if (switching.final) {
                    switching.final.forEach(competitor => {
                        if (competitor.score === 9 || competitor.score === 3 || competitor.score === 1) {
                            delete competitor['score']
                            delete competitor['hasWon']
                            championsArray.push(competitor)
                            countChamp++
                        }
                        count++
                    })
                }

                if (count === 1 && countChamp === 0) {
                    championsArray.push(switching.final[0])
                }
            }
        })

        /* Get champions of every rotation */
        const rotations = await getRotationsFromChamp(champId);
        rotations.forEach(rotation => {
            rotation.val().competitors.forEach(competitor => {
                if (competitor.score === 9) {
                    delete competitor['score']
                    delete competitor['hasWon']
                    championsArray.push(competitor)
                }
            })
        });
        sessionStorage.setItem('switchingArrayOfChampions', JSON.stringify(championsArray));

        /* Get all teams */
        let localArray = await getTeams();

        sessionStorage.setItem('switchingArrayOfTeams', JSON.stringify(localArray));
    }

    chooseSwitching = (value) => {
        this.setState({
            switchingId: value
        })
    }

    render() {
        return (
            <SwitchingContainerView
                champObject={this.state.champObject}
                champId={this.state.champId}

                loadingSwitchingList={this.state.loadingSwitchingList}
                switchingList={this.state.switchingList}
                chooseSwitching={e => this.chooseSwitching(e)}

                switchingId={this.state.switchingId}
            />
        )
    }

}

export default SwitchingContainer